// Import all custom Builder.io components,
// so that they are bundled and accessible
import { Builder } from '@builder.io/react';
import '@/components/features/cms/blocks/Accordion';
import '@/components/features/cms/blocks/ArticleHeader';
import '@/components/features/cms/blocks/AuthorCard';
import '@/components/features/cms/blocks/AvatarLink';
import '@/components/features/cms/blocks/BlogOverview';
import '@/components/features/cms/blocks/Button';
import '@/components/features/cms/blocks/BuyButton';
import '@/components/features/cms/blocks/Carousel';
import '@/components/features/cms/blocks/DamImage';
import '@/components/features/cms/blocks/DamVideo';
import '@/components/features/cms/blocks/DynamicProductSlider';
import '@/components/features/cms/blocks/Icon';
import '@/components/features/cms/blocks/Modal';
import '@/components/features/cms/blocks/ProductCard';
import '@/components/features/cms/blocks/Script';
import '@/components/features/cms/blocks/Section';
import '@/components/features/cms/blocks/StaticProductSlider';
import '@/components/features/cms/blocks/Tabs';
import '@/components/features/cms/blocks/TeaserCard';
import '@/components/features/cms/blocks/TeaserCardSlider';
import '@/components/features/cms/blocks/Text';
import '@/components/features/cms/blocks/ThirdPartyBlock';
import '@/components/features/cms/blocks/VerticalSpacer';

Builder.register('editor.settings', {
	customInsertMenu: true,
	allowOverridingTokens: true,
	designTokensOptional: true,
	designTokens: {
		backgroundColor: [
			{ name: 'Background Neutral Default', value: 'var(--color-neutral-0, #ffffff)' },
			{ name: 'Background Neutral Inverse', value: 'var(--color-neutral-900, #3f3e3e)' },
			{ name: 'Background Neutral Stronger', value: 'var(--color-neutral-700, #6f6e6e)' },
			{ name: 'Background Neutral Weak', value: 'var(--color-neutral-200, #e0dedc)' },
			{ name: 'Background Neutral Weaker', value: 'var(--color-neutral-100, #ebe9e6)' },
			{ name: 'Background Primary Default', value: 'var(--color-primary-500, #3793a3)' },
			{ name: 'Background Primary Weaker', value: 'var(--color-primary-200, #cde4e8)' },
			{ name: 'Background Secondary Default', value: 'var(--color-secondary-200, #f2f0ed)' },
			{ name: 'Background Secondary Stronger', value: 'var(--color-secondary-500, #e6ddc6)' },
			{ name: 'Background System Danger', value: 'var(--color-system-danger-500, #b72941)' },
			{ name: 'Background System Danger Weaker', value: 'var(--color-system-danger-300, #fcefee)' },
			{ name: 'Background System Success', value: 'var(--color-system-success-500, #4d8f62)' },
			{ name: 'Background System Success Weaker', value: 'var(--color-system-success-300, #eafcef)' },
			{ name: 'Background System Warning', value: 'var(--color-system-warning-500, #e0a819)' },
			{ name: 'Background System Warning Weaker', value: 'var(--color-system-warning-300, #fcf6e5)' },
		],
		borderColor: [
			{ name: 'Border Default', value: 'var(--color-neutral-300, #cfcecd)' },
			{ name: 'Border Inverse', value: 'var(--color-neutral-0, #ffffff)' },
			{ name: 'Border Primary', value: 'var(--color-primary-500, #3793a3)' },
			{ name: 'Border Danger', value: 'var(--color-system-danger-500, #b72941)' },
			{ name: 'Border Warning', value: 'var(--color-system-warning-500, #e0a819)' },
			{ name: 'Border Success', value: 'var(--color-system-success-500, #4d8f62)' },
		],
		colors: [
			{ name: 'Text Neutral Default', value: 'var(--color-neutral-900, #3f3e3e)' },
			{ name: 'Text Neutral Inverse', value: 'var(--color-neutral-0, #ffffff)' },
			{ name: 'Text Neutral Strong', value: 'var(--color-neutral-500, #9f9e9e)' },
			{ name: 'Text Neutral Stronger', value: 'var(--color-neutral-700, #6f6e6e)' },
			{ name: 'Text Primary Default', value: 'var(--color-primary-500, #3793a3)' },
			{ name: 'Text System Danger', value: 'var(--color-system-danger-500, #b72941)' },
		],

		fontFamily: false,
		fontSize: [
			{ name: 'Body XS', value: 'var(--font-size-body-xs, 12px)' },
			{ name: 'Body SM', value: 'var(--font-size-body-sm, 14px)' },
			{ name: 'Body MD', value: 'var(--font-size-body-md, 16px)' },
			{ name: 'Body LG', value: 'var(--font-size-body-lg, 18px)' },
			{ name: 'Heading 1', value: 'var(--font-size-heading-1, 48px)' },
			{ name: 'Heading 2', value: 'var(--font-size-heading-2, 40px)' },
			{ name: 'Heading 3', value: 'var(--font-size-heading-3, 32px)' },
			{ name: 'Heading 4', value: 'var(--font-size-heading-4, 24px)' },
			{ name: 'Heading 5', value: 'var(--font-size-heading-5, 20px)' },
			{ name: 'Heading 6', value: 'var(--font-size-heading-6, 18px)' },
		],
		fontWeight: [
			{ name: 'Regular', value: 'var(--font-weight-regular, 400)' },
			{ name: 'Medium', value: 'var(--font-weight-medium, 500)' },
		],

		spacing: [
			{ name: 'None', value: 'var(--spacing-none, 0px)' },
			{ name: '3xs', value: 'var(--spacing-3xs, 2px)' },
			{ name: '2xs', value: 'var(--spacing-2xs, 4px)' },
			{ name: 'xs', value: 'var(--spacing-xs, 8px)' },
			{ name: 'sm', value: 'var(--spacing-sm, 12px)' },
			{ name: 'md', value: 'var(--spacing-md, 16px)' },
			{ name: 'lg', value: 'var(--spacing-lg, 24px)' },
			{ name: 'xl', value: 'var(--spacing-xl, 32px)' },
			{ name: '2xl', value: 'var(--spacing-2xl, 40px)' },
			{ name: '3xl', value: 'var(--spacing-3xl, 64px)' },
			{ name: '4xl', value: 'var(--spacing-4xl, 128px)' },
		],
	},
});

Builder.register('insertMenu', {
	name: 'Bizzkit Content',
	priority: 1,
	items: [
		{ name: 'ArticleHeader' },
		{ name: 'AuthorCard' },
		{ name: 'AvatarLink' },
		{ name: 'BlogOverview' },
		{ name: 'Core:Button' },
		{ name: 'DAMImage' },
		{ name: 'DAMVideo' },
		{ name: 'Icon' },
		{ name: 'TeaserCard' },
		{ name: 'TeaserCardSlider' },
		{ name: 'Text' },
	],
});

Builder.register('insertMenu', {
	name: 'Bizzkit Layout',
	priority: 2,
	items: [
		{ name: 'Accordion' },
		{ name: 'Box' },
		{ name: 'Carousel' },
		{ name: 'Columns' },
		{ name: 'Core:Section' },
		{ name: 'Tabs' },
		{ name: 'VerticalSpacer' },
	],
});

Builder.register('insertMenu', {
	name: 'Bizzkit E-commerce',
	priority: 3,
	items: [
		{ name: 'BuyButton' },
		{ name: 'ProductCard' },
		{ name: 'DynamicProductSlider' },
		{ name: 'StaticProductSlider' },
	],
});

Builder.register('insertMenu', {
	name: 'Bizzkit Advanced',
	priority: 4,
	items: [
		{ name: 'Embed' },
		{ name: 'JourneysMarketingForms' },
		{ name: 'Modal' },
		{ name: 'Slot' },
		{ name: 'Symbol' },
		{ name: 'ThirdPartyBlock' },
	],
});
